(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './connect-fs-fs-s2-file-fs-file-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./connect-fs-fs-s2-file-fs-file-domain.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-commons-commons-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-infra-commons-commons-domain'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-commons-commons-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-infra-commons-commons-domain'.");
    }
    if (typeof this['connect-fs-fs-s2-file-fs-file-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-commons-commons-domain'. Its dependency 'connect-fs-fs-s2-file-fs-file-domain' was not found. Please, check whether 'connect-fs-fs-s2-file-fs-file-domain' is loaded prior to 'boislocal-platform-platform-infra-commons-commons-domain'.");
    }
    root['boislocal-platform-platform-infra-commons-commons-domain'] = factory(typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-infra-commons-commons-domain'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['connect-fs-fs-s2-file-fs-file-domain']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_komune_fs_fs_file_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var VOID = kotlin_kotlin.$_$.g;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var objectCreate = kotlin_kotlin.$_$.da;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var defineProp = kotlin_kotlin.$_$.b9;
  var classMeta = kotlin_kotlin.$_$.z8;
  var equals = kotlin_kotlin.$_$.c9;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Long = kotlin_kotlin.$_$.ed;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var emptyMap = kotlin_kotlin.$_$.c6;
  var hashCode = kotlin_kotlin.$_$.j9;
  var split = kotlin_kotlin.$_$.wb;
  var takeLast = kotlin_kotlin.$_$.k7;
  var FilePath = kotlin_io_komune_fs_fs_file_domain.$_$.a;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var getNumberHashCode = kotlin_kotlin.$_$.g9;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var emptyList = kotlin_kotlin.$_$.b6;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var getKClass = kotlin_kotlin.$_$.f;
  var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var contains = kotlin_kotlin.$_$.k5;
  //endregion
  //region block: pre-declaration
  setMetadataFor(AddressDTO, 'AddressDTO', interfaceMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Address, 'Address', classMeta, VOID, [AddressDTO], VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(CityDTO, 'CityDTO', interfaceMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(City, 'City', classMeta, VOID, [CityDTO], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(CreditedFileDTO, 'CreditedFileDTO', interfaceMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CreditedFile, 'CreditedFile', classMeta, VOID, [CreditedFileDTO], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(CreditedFileCommandDTO, 'CreditedFileCommandDTO', interfaceMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CreditedFileCommand, 'CreditedFileCommand', classMeta, VOID, [CreditedFileCommandDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(DepartmentDTO, 'DepartmentDTO', interfaceMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Department, 'Department', classMeta, VOID, [DepartmentDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(ExternalFileDTO, 'ExternalFileDTO', interfaceMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ExternalFile, 'ExternalFile', classMeta, VOID, [ExternalFileDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(GeoCircleDTO, 'GeoCircleDTO', interfaceMeta);
  setMetadataFor(GeoCoordinatesDTO, 'GeoCoordinatesDTO', interfaceMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(GeoCoordinates, 'GeoCoordinates', classMeta, VOID, [GeoCoordinatesDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(FeatureCollection, 'FeatureCollection', classMeta, VOID, VOID, FeatureCollection, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Feature, 'Feature', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Point, 'Point', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(IdRefDTO, 'IdRefDTO', interfaceMeta);
  setMetadataFor(Companion_3, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor($serializer_9, '$serializer', classMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(IdRef, 'IdRef', classMeta, VOID, [IdRefDTO], VOID, VOID, {0: Companion_getInstance_3});
  setMetadataFor(IndicatorDTO, 'IndicatorDTO', interfaceMeta);
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Indicator, 'Indicator', classMeta, VOID, [IndicatorDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(ObjectRefDTO, 'ObjectRefDTO', interfaceMeta, VOID, [IdRefDTO]);
  setMetadataFor(OrganizationRefDTO, 'OrganizationRefDTO', interfaceMeta, VOID, [ObjectRefDTO]);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationRef, 'OrganizationRef', classMeta, VOID, [OrganizationRefDTO], VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(AuthedUserDTO, 'AuthedUserDTO', interfaceMeta);
  setMetadataFor(Roles, 'Roles', objectMeta);
  //endregion
  function AddressDTO() {
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.Address', this, 3);
    tmp0_serialDesc.ht('city', false);
    tmp0_serialDesc.ht('street', false);
    tmp0_serialDesc.ht('postalCode', false);
    this.k28_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.k28_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.k28_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return Address_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer).l28 = function (encoder, value) {
    var tmp0_desc = this.k28_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.m28_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.n28_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.o28_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.l28(encoder, value instanceof Address ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function Address_init_$Init$(seen1, city, street, postalCode, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance().k28_1);
    }
    $this.m28_1 = city;
    $this.n28_1 = street;
    $this.o28_1 = postalCode;
    return $this;
  }
  function Address_init_$Create$(seen1, city, street, postalCode, serializationConstructorMarker) {
    return Address_init_$Init$(seen1, city, street, postalCode, serializationConstructorMarker, objectCreate(protoOf(Address)));
  }
  function Address() {
  }
  protoOf(Address).j28 = function () {
    return this.m28_1;
  };
  protoOf(Address).h28 = function () {
    return this.n28_1;
  };
  protoOf(Address).i28 = function () {
    return this.o28_1;
  };
  protoOf(Address).toString = function () {
    return 'Address(city=' + this.m28_1 + ', street=' + this.n28_1 + ', postalCode=' + this.o28_1 + ')';
  };
  protoOf(Address).hashCode = function () {
    var result = getStringHashCode(this.m28_1);
    result = imul(result, 31) + (this.n28_1 == null ? 0 : getStringHashCode(this.n28_1)) | 0;
    result = imul(result, 31) + (this.o28_1 == null ? 0 : getStringHashCode(this.o28_1)) | 0;
    return result;
  };
  protoOf(Address).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Address))
      return false;
    var tmp0_other_with_cast = other instanceof Address ? other : THROW_CCE();
    if (!(this.m28_1 === tmp0_other_with_cast.m28_1))
      return false;
    if (!(this.n28_1 == tmp0_other_with_cast.n28_1))
      return false;
    if (!(this.o28_1 == tmp0_other_with_cast.o28_1))
      return false;
    return true;
  };
  function CityDTO() {
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.City', this, 2);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('code', false);
    this.p28_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.p28_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.p28_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return City_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).q28 = function (encoder, value) {
    var tmp0_desc = this.p28_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.r28_1);
    tmp1_output.jn(tmp0_desc, 1, value.s28_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.q28(encoder, value instanceof City ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function City_init_$Init$(seen1, name, code, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_0().p28_1);
    }
    $this.r28_1 = name;
    $this.s28_1 = code;
    return $this;
  }
  function City_init_$Create$(seen1, name, code, serializationConstructorMarker) {
    return City_init_$Init$(seen1, name, code, serializationConstructorMarker, objectCreate(protoOf(City)));
  }
  function City() {
  }
  protoOf(City).h9 = function () {
    return this.r28_1;
  };
  protoOf(City).m1y = function () {
    return this.s28_1;
  };
  protoOf(City).toString = function () {
    return 'City(name=' + this.r28_1 + ', code=' + this.s28_1 + ')';
  };
  protoOf(City).hashCode = function () {
    var result = getStringHashCode(this.r28_1);
    result = imul(result, 31) + getStringHashCode(this.s28_1) | 0;
    return result;
  };
  protoOf(City).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof City))
      return false;
    var tmp0_other_with_cast = other instanceof City ? other : THROW_CCE();
    if (!(this.r28_1 === tmp0_other_with_cast.r28_1))
      return false;
    if (!(this.s28_1 === tmp0_other_with_cast.s28_1))
      return false;
    return true;
  };
  function CreditedFileDTO() {
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.CreditedFile', this, 3);
    tmp0_serialDesc.ht('file', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('credit', false);
    this.v28_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.v28_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.v28_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return CreditedFile_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_1).w28 = function (encoder, value) {
    var tmp0_desc = this.v28_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.x28_1);
    tmp1_output.jn(tmp0_desc, 1, value.y28_1);
    tmp1_output.jn(tmp0_desc, 2, value.z28_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.w28(encoder, value instanceof CreditedFile ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function CreditedFile_init_$Init$(seen1, file, name, credit, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_1().v28_1);
    }
    $this.x28_1 = file;
    $this.y28_1 = name;
    $this.z28_1 = credit;
    return $this;
  }
  function CreditedFile_init_$Create$(seen1, file, name, credit, serializationConstructorMarker) {
    return CreditedFile_init_$Init$(seen1, file, name, credit, serializationConstructorMarker, objectCreate(protoOf(CreditedFile)));
  }
  function CreditedFile() {
  }
  protoOf(CreditedFile).t28 = function () {
    return this.x28_1;
  };
  protoOf(CreditedFile).h9 = function () {
    return this.y28_1;
  };
  protoOf(CreditedFile).u28 = function () {
    return this.z28_1;
  };
  protoOf(CreditedFile).toString = function () {
    return 'CreditedFile(file=' + this.x28_1 + ', name=' + this.y28_1 + ', credit=' + this.z28_1 + ')';
  };
  protoOf(CreditedFile).hashCode = function () {
    var result = getStringHashCode(this.x28_1);
    result = imul(result, 31) + getStringHashCode(this.y28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z28_1) | 0;
    return result;
  };
  protoOf(CreditedFile).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreditedFile))
      return false;
    var tmp0_other_with_cast = other instanceof CreditedFile ? other : THROW_CCE();
    if (!(this.x28_1 === tmp0_other_with_cast.x28_1))
      return false;
    if (!(this.y28_1 === tmp0_other_with_cast.y28_1))
      return false;
    if (!(this.z28_1 === tmp0_other_with_cast.z28_1))
      return false;
    return true;
  };
  function CreditedFileCommandDTO() {
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.CreditedFileCommand', this, 3);
    tmp0_serialDesc.ht('toAdd', false);
    tmp0_serialDesc.ht('toRemove', false);
    tmp0_serialDesc.ht('toUseAsCover', false);
    this.d29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.d29_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_1()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.d29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.im(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.im(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return CreditedFileCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_2).e29 = function (encoder, value) {
    var tmp0_desc = this.d29_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.nn(tmp0_desc, 0, $serializer_getInstance_1(), value.f29_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.g29_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.h29_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.e29(encoder, value instanceof CreditedFileCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function CreditedFileCommand_init_$Init$(seen1, toAdd, toRemove, toUseAsCover, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_2().d29_1);
    }
    $this.f29_1 = toAdd;
    $this.g29_1 = toRemove;
    $this.h29_1 = toUseAsCover;
    return $this;
  }
  function CreditedFileCommand_init_$Create$(seen1, toAdd, toRemove, toUseAsCover, serializationConstructorMarker) {
    return CreditedFileCommand_init_$Init$(seen1, toAdd, toRemove, toUseAsCover, serializationConstructorMarker, objectCreate(protoOf(CreditedFileCommand)));
  }
  function CreditedFileCommand() {
  }
  protoOf(CreditedFileCommand).a29 = function () {
    return this.f29_1;
  };
  protoOf(CreditedFileCommand).b29 = function () {
    return this.g29_1;
  };
  protoOf(CreditedFileCommand).c29 = function () {
    return this.h29_1;
  };
  protoOf(CreditedFileCommand).toString = function () {
    return 'CreditedFileCommand(toAdd=' + this.f29_1 + ', toRemove=' + this.g29_1 + ', toUseAsCover=' + this.h29_1 + ')';
  };
  protoOf(CreditedFileCommand).hashCode = function () {
    var result = this.f29_1 == null ? 0 : this.f29_1.hashCode();
    result = imul(result, 31) + (this.g29_1 == null ? 0 : getStringHashCode(this.g29_1)) | 0;
    result = imul(result, 31) + (this.h29_1 == null ? 0 : getStringHashCode(this.h29_1)) | 0;
    return result;
  };
  protoOf(CreditedFileCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreditedFileCommand))
      return false;
    var tmp0_other_with_cast = other instanceof CreditedFileCommand ? other : THROW_CCE();
    if (!equals(this.f29_1, tmp0_other_with_cast.f29_1))
      return false;
    if (!(this.g29_1 == tmp0_other_with_cast.g29_1))
      return false;
    if (!(this.h29_1 == tmp0_other_with_cast.h29_1))
      return false;
    return true;
  };
  function DepartmentDTO() {
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.Department', this, 2);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('code', false);
    this.i29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.i29_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.i29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return Department_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).j29 = function (encoder, value) {
    var tmp0_desc = this.i29_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.k29_1);
    tmp1_output.fn(tmp0_desc, 1, value.l29_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.j29(encoder, value instanceof Department ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function Department_init_$Init$(seen1, name, code, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_3().i29_1);
    }
    $this.k29_1 = name;
    $this.l29_1 = code;
    return $this;
  }
  function Department_init_$Create$(seen1, name, code, serializationConstructorMarker) {
    return Department_init_$Init$(seen1, name, code, serializationConstructorMarker, objectCreate(protoOf(Department)));
  }
  function Department() {
  }
  protoOf(Department).h9 = function () {
    return this.k29_1;
  };
  protoOf(Department).m1y = function () {
    return this.l29_1;
  };
  protoOf(Department).toString = function () {
    return 'Department(name=' + this.k29_1 + ', code=' + this.l29_1.toString() + ')';
  };
  protoOf(Department).hashCode = function () {
    var result = getStringHashCode(this.k29_1);
    result = imul(result, 31) + this.l29_1.hashCode() | 0;
    return result;
  };
  protoOf(Department).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Department))
      return false;
    var tmp0_other_with_cast = other instanceof Department ? other : THROW_CCE();
    if (!(this.k29_1 === tmp0_other_with_cast.k29_1))
      return false;
    if (!this.l29_1.equals(tmp0_other_with_cast.l29_1))
      return false;
    return true;
  };
  function get_METADATA_CREDIT_KEY() {
    return METADATA_CREDIT_KEY;
  }
  var METADATA_CREDIT_KEY;
  function ExternalFileDTO() {
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n29_1 = [null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
  }
  protoOf(Companion).x14 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.ExternalFile', this, 4);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('url', true);
    tmp0_serialDesc.ht('path', true);
    tmp0_serialDesc.ht('metadata', true);
    this.o29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.o29_1;
  };
  protoOf($serializer_4).wt = function () {
    var tmp0_cached = Companion_getInstance().n29_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[3]];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.o29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance().n29_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.gm(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.gm(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return ExternalFile_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_4).p29 = function (encoder, value) {
    var tmp0_desc = this.o29_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance().n29_1;
    tmp1_output.jn(tmp0_desc, 0, value.q29_1);
    if (tmp1_output.rn(tmp0_desc, 1) ? true : !(value.r29_1 == null)) {
      tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.r29_1);
    }
    var tmp;
    if (tmp1_output.rn(tmp0_desc, 2)) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = value.r29_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.boislocal.platform.s2.commons.domain.model.$serializer.serialize.<anonymous>' call
        tmp_0 = getPathFromUrl(tmp0_safe_receiver).toString();
      }
      tmp = !(value.s29_1 == tmp_0);
    }
    if (tmp) {
      tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.s29_1);
    }
    if (tmp1_output.rn(tmp0_desc, 3) ? true : !equals(value.t29_1, emptyMap())) {
      tmp1_output.ln(tmp0_desc, 3, tmp2_cached[3], value.t29_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.p29(encoder, value instanceof ExternalFile ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function ExternalFile_init_$Init$(seen1, name, url, path, metadata, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_4().o29_1);
    }
    $this.q29_1 = name;
    if (0 === (seen1 & 2))
      $this.r29_1 = null;
    else
      $this.r29_1 = url;
    if (0 === (seen1 & 4)) {
      var tmp = $this;
      var tmp0_safe_receiver = $this.r29_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.boislocal.platform.s2.commons.domain.model.ExternalFile.<init>.<anonymous>' call
        tmp_0 = getPathFromUrl(tmp0_safe_receiver).toString();
      }
      tmp.s29_1 = tmp_0;
    } else
      $this.s29_1 = path;
    if (0 === (seen1 & 8))
      $this.t29_1 = emptyMap();
    else
      $this.t29_1 = metadata;
    return $this;
  }
  function ExternalFile_init_$Create$(seen1, name, url, path, metadata, serializationConstructorMarker) {
    return ExternalFile_init_$Init$(seen1, name, url, path, metadata, serializationConstructorMarker, objectCreate(protoOf(ExternalFile)));
  }
  function ExternalFile(name, url, path, metadata) {
    Companion_getInstance();
    url = url === VOID ? null : url;
    var tmp;
    if (path === VOID) {
      var tmp0_safe_receiver = url;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.boislocal.platform.s2.commons.domain.model.ExternalFile.<init>.<anonymous>' call
        tmp_0 = getPathFromUrl(tmp0_safe_receiver).toString();
      }
      tmp = tmp_0;
    } else {
      tmp = path;
    }
    path = tmp;
    metadata = metadata === VOID ? emptyMap() : metadata;
    this.q29_1 = name;
    this.r29_1 = url;
    this.s29_1 = path;
    this.t29_1 = metadata;
  }
  protoOf(ExternalFile).h9 = function () {
    return this.q29_1;
  };
  protoOf(ExternalFile).v21 = function () {
    return this.r29_1;
  };
  protoOf(ExternalFile).m29 = function () {
    return this.s29_1;
  };
  protoOf(ExternalFile).w27 = function () {
    return this.t29_1;
  };
  protoOf(ExternalFile).md = function () {
    return this.q29_1;
  };
  protoOf(ExternalFile).nd = function () {
    return this.r29_1;
  };
  protoOf(ExternalFile).s22 = function () {
    return this.s29_1;
  };
  protoOf(ExternalFile).t22 = function () {
    return this.t29_1;
  };
  protoOf(ExternalFile).u29 = function (name, url, path, metadata) {
    return new ExternalFile(name, url, path, metadata);
  };
  protoOf(ExternalFile).copy = function (name, url, path, metadata, $super) {
    name = name === VOID ? this.q29_1 : name;
    url = url === VOID ? this.r29_1 : url;
    path = path === VOID ? this.s29_1 : path;
    metadata = metadata === VOID ? this.t29_1 : metadata;
    return this.u29(name, url, path, metadata);
  };
  protoOf(ExternalFile).toString = function () {
    return 'ExternalFile(name=' + this.q29_1 + ', url=' + this.r29_1 + ', path=' + this.s29_1 + ', metadata=' + this.t29_1 + ')';
  };
  protoOf(ExternalFile).hashCode = function () {
    var result = getStringHashCode(this.q29_1);
    result = imul(result, 31) + (this.r29_1 == null ? 0 : getStringHashCode(this.r29_1)) | 0;
    result = imul(result, 31) + (this.s29_1 == null ? 0 : getStringHashCode(this.s29_1)) | 0;
    result = imul(result, 31) + hashCode(this.t29_1) | 0;
    return result;
  };
  protoOf(ExternalFile).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ExternalFile))
      return false;
    var tmp0_other_with_cast = other instanceof ExternalFile ? other : THROW_CCE();
    if (!(this.q29_1 === tmp0_other_with_cast.q29_1))
      return false;
    if (!(this.r29_1 == tmp0_other_with_cast.r29_1))
      return false;
    if (!(this.s29_1 == tmp0_other_with_cast.s29_1))
      return false;
    if (!equals(this.t29_1, tmp0_other_with_cast.t29_1))
      return false;
    return true;
  };
  function getPathFromUrl(url) {
    var tmp0_container = takeLast(split(url, ['/']), 4);
    // Inline function 'kotlin.collections.component1' call
    var objectType = tmp0_container.f1(0);
    // Inline function 'kotlin.collections.component2' call
    var objectId = tmp0_container.f1(1);
    // Inline function 'kotlin.collections.component3' call
    var directory = tmp0_container.f1(2);
    // Inline function 'kotlin.collections.component4' call
    var name = tmp0_container.f1(3);
    return new FilePath(objectType, objectId, directory, name);
  }
  function GeoCircleDTO() {
  }
  function GeoCoordinatesDTO() {
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.GeoCoordinates', this, 3);
    tmp0_serialDesc.ht('address', true);
    tmp0_serialDesc.ht('longitude', false);
    tmp0_serialDesc.ht('latitude', false);
    this.a2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.a2a_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.a2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.im(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.cm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.cm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.im(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.cm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.cm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return GeoCoordinates_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_5).b2a = function (encoder, value) {
    var tmp0_desc = this.a2a_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    if (tmp1_output.rn(tmp0_desc, 0) ? true : !(value.c2a_1 == null)) {
      tmp1_output.nn(tmp0_desc, 0, StringSerializer_getInstance(), value.c2a_1);
    }
    tmp1_output.hn(tmp0_desc, 1, value.d2a_1);
    tmp1_output.hn(tmp0_desc, 2, value.e2a_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.b2a(encoder, value instanceof GeoCoordinates ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function GeoCoordinates_init_$Init$(seen1, address, longitude, latitude, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen1))) {
      throwMissingFieldException(seen1, 6, $serializer_getInstance_5().a2a_1);
    }
    if (0 === (seen1 & 1))
      $this.c2a_1 = null;
    else
      $this.c2a_1 = address;
    $this.d2a_1 = longitude;
    $this.e2a_1 = latitude;
    return $this;
  }
  function GeoCoordinates_init_$Create$(seen1, address, longitude, latitude, serializationConstructorMarker) {
    return GeoCoordinates_init_$Init$(seen1, address, longitude, latitude, serializationConstructorMarker, objectCreate(protoOf(GeoCoordinates)));
  }
  function GeoCoordinates() {
  }
  protoOf(GeoCoordinates).x29 = function () {
    return this.c2a_1;
  };
  protoOf(GeoCoordinates).y29 = function () {
    return this.d2a_1;
  };
  protoOf(GeoCoordinates).z29 = function () {
    return this.e2a_1;
  };
  protoOf(GeoCoordinates).toString = function () {
    return 'GeoCoordinates(address=' + this.c2a_1 + ', longitude=' + this.d2a_1 + ', latitude=' + this.e2a_1 + ')';
  };
  protoOf(GeoCoordinates).hashCode = function () {
    var result = this.c2a_1 == null ? 0 : getStringHashCode(this.c2a_1);
    result = imul(result, 31) + getNumberHashCode(this.d2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e2a_1) | 0;
    return result;
  };
  protoOf(GeoCoordinates).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GeoCoordinates))
      return false;
    var tmp0_other_with_cast = other instanceof GeoCoordinates ? other : THROW_CCE();
    if (!(this.c2a_1 == tmp0_other_with_cast.c2a_1))
      return false;
    if (!equals(this.d2a_1, tmp0_other_with_cast.d2a_1))
      return false;
    if (!equals(this.e2a_1, tmp0_other_with_cast.e2a_1))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f2a_1 = [null, new ArrayListSerializer($serializer_getInstance_7())];
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.FeatureCollection', this, 2);
    tmp0_serialDesc.ht('type', true);
    tmp0_serialDesc.ht('features', true);
    this.g2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.g2a_1;
  };
  protoOf($serializer_6).wt = function () {
    var tmp0_cached = Companion_getInstance_0().f2a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1]];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.g2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    var tmp7_cached = Companion_getInstance_0().f2a_1;
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return FeatureCollection_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_6).h2a = function (encoder, value) {
    var tmp0_desc = this.g2a_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_0().f2a_1;
    if (tmp1_output.rn(tmp0_desc, 0) ? true : !(value.i2a_1 === 'FeatureCollection')) {
      tmp1_output.jn(tmp0_desc, 0, value.i2a_1);
    }
    if (tmp1_output.rn(tmp0_desc, 1) ? true : !equals(value.j2a_1, emptyList())) {
      tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.j2a_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.h2a(encoder, value instanceof FeatureCollection ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function FeatureCollection_init_$Init$(seen1, type, features, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_6().g2a_1);
    }
    if (0 === (seen1 & 1))
      $this.i2a_1 = 'FeatureCollection';
    else
      $this.i2a_1 = type;
    if (0 === (seen1 & 2))
      $this.j2a_1 = emptyList();
    else
      $this.j2a_1 = features;
    return $this;
  }
  function FeatureCollection_init_$Create$(seen1, type, features, serializationConstructorMarker) {
    return FeatureCollection_init_$Init$(seen1, type, features, serializationConstructorMarker, objectCreate(protoOf(FeatureCollection)));
  }
  function FeatureCollection(type, features) {
    Companion_getInstance_0();
    type = type === VOID ? 'FeatureCollection' : type;
    features = features === VOID ? emptyList() : features;
    this.i2a_1 = type;
    this.j2a_1 = features;
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2a_1 = [null, new LinkedHashMapSerializer(StringSerializer_getInstance(), DoubleSerializer_getInstance()), null];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.Feature', this, 3);
    tmp0_serialDesc.ht('type', true);
    tmp0_serialDesc.ht('properties', false);
    tmp0_serialDesc.ht('geometry', false);
    this.l2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.l2a_1;
  };
  protoOf($serializer_7).wt = function () {
    var tmp0_cached = Companion_getInstance_1().k2a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], $serializer_getInstance_8()];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.l2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    var tmp8_cached = Companion_getInstance_1().k2a_1;
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.gm(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.gm(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.gm(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.gm(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return Feature_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_7).m2a = function (encoder, value) {
    var tmp0_desc = this.l2a_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().k2a_1;
    if (tmp1_output.rn(tmp0_desc, 0) ? true : !(value.n2a_1 === 'Feature')) {
      tmp1_output.jn(tmp0_desc, 0, value.n2a_1);
    }
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.o2a_1);
    tmp1_output.ln(tmp0_desc, 2, $serializer_getInstance_8(), value.p2a_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.m2a(encoder, value instanceof Feature ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function Feature_init_$Init$(seen1, type, properties, geometry, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen1))) {
      throwMissingFieldException(seen1, 6, $serializer_getInstance_7().l2a_1);
    }
    if (0 === (seen1 & 1))
      $this.n2a_1 = 'Feature';
    else
      $this.n2a_1 = type;
    $this.o2a_1 = properties;
    $this.p2a_1 = geometry;
    return $this;
  }
  function Feature_init_$Create$(seen1, type, properties, geometry, serializationConstructorMarker) {
    return Feature_init_$Init$(seen1, type, properties, geometry, serializationConstructorMarker, objectCreate(protoOf(Feature)));
  }
  function Feature() {
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2a_1 = [null, new ArrayListSerializer(DoubleSerializer_getInstance())];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.Point', this, 2);
    tmp0_serialDesc.ht('type', true);
    tmp0_serialDesc.ht('coordinates', false);
    this.r2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.r2a_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_2().q2a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1]];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.r2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    var tmp7_cached = Companion_getInstance_2().q2a_1;
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return Point_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_8).s2a = function (encoder, value) {
    var tmp0_desc = this.r2a_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().q2a_1;
    if (tmp1_output.rn(tmp0_desc, 0) ? true : !(value.t2a_1 === 'Point')) {
      tmp1_output.jn(tmp0_desc, 0, value.t2a_1);
    }
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.u2a_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.s2a(encoder, value instanceof Point ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function Point_init_$Init$(seen1, type, coordinates, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen1))) {
      throwMissingFieldException(seen1, 2, $serializer_getInstance_8().r2a_1);
    }
    if (0 === (seen1 & 1))
      $this.t2a_1 = 'Point';
    else
      $this.t2a_1 = type;
    $this.u2a_1 = coordinates;
    return $this;
  }
  function Point_init_$Create$(seen1, type, coordinates, serializationConstructorMarker) {
    return Point_init_$Init$(seen1, type, coordinates, serializationConstructorMarker, objectCreate(protoOf(Point)));
  }
  function Point() {
  }
  function IdRefDTO() {
  }
  function $serializer_init_$Init$(typeSerial0, $this) {
    $serializer_9.call($this);
    $this.w2a_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$(typeSerial0) {
    return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_9)));
  }
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.IdRef', null, 1);
    tmp0_serialDesc.ht('id', false);
    this.x2a_1 = tmp0_serialDesc;
  }
  protoOf(Companion_3).n1z = function (typeSerial0) {
    return $serializer_init_$Create$(typeSerial0);
  };
  protoOf(Companion_3).hu = function (typeParamsSerializers) {
    return this.n1z(typeParamsSerializers[0]);
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function $serializer_9() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.IdRef', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.v2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ii = function () {
    return this.v2a_1;
  };
  protoOf($serializer_9).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.w2a_1];
  };
  protoOf($serializer_9).ki = function (decoder) {
    var tmp0_desc = this.v2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, this.w2a_1, tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, this.w2a_1, tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return IdRef_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_9).y2a = function (encoder, value) {
    var tmp0_desc = this.v2a_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, this.w2a_1, value.z2a_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_9).ji = function (encoder, value) {
    return this.y2a(encoder, value instanceof IdRef ? value : THROW_CCE());
  };
  protoOf($serializer_9).xt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.w2a_1];
  };
  function IdRef_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, Companion_getInstance_3().x2a_1);
    }
    $this.z2a_1 = id;
    return $this;
  }
  function IdRef_init_$Create$(seen1, id, serializationConstructorMarker) {
    return IdRef_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(IdRef)));
  }
  function IdRef() {
  }
  protoOf(IdRef).k1y = function () {
    return this.z2a_1;
  };
  function IndicatorDTO() {
  }
  function $serializer_10() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.Indicator', this, 2);
    tmp0_serialDesc.ht('value', false);
    tmp0_serialDesc.ht('unit', false);
    this.b2b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).ii = function () {
    return this.b2b_1;
  };
  protoOf($serializer_10).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_10).ki = function (decoder) {
    var tmp0_desc = this.b2b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.cm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.cm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return Indicator_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_10).c2b = function (encoder, value) {
    var tmp0_desc = this.b2b_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.hn(tmp0_desc, 0, value.d2b_1);
    tmp1_output.jn(tmp0_desc, 1, value.e2b_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_10).ji = function (encoder, value) {
    return this.c2b(encoder, value instanceof Indicator ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_10();
    return $serializer_instance_9;
  }
  function Indicator_init_$Init$(seen1, value, unit, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_9().b2b_1);
    }
    $this.d2b_1 = value;
    $this.e2b_1 = unit;
    return $this;
  }
  function Indicator_init_$Create$(seen1, value, unit, serializationConstructorMarker) {
    return Indicator_init_$Init$(seen1, value, unit, serializationConstructorMarker, objectCreate(protoOf(Indicator)));
  }
  function Indicator() {
  }
  protoOf(Indicator).f2 = function () {
    return this.d2b_1;
  };
  protoOf(Indicator).a2b = function () {
    return this.e2b_1;
  };
  protoOf(Indicator).toString = function () {
    return 'Indicator(value=' + this.d2b_1 + ', unit=' + this.e2b_1 + ')';
  };
  protoOf(Indicator).hashCode = function () {
    var result = getNumberHashCode(this.d2b_1);
    result = imul(result, 31) + getStringHashCode(this.e2b_1) | 0;
    return result;
  };
  protoOf(Indicator).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Indicator))
      return false;
    var tmp0_other_with_cast = other instanceof Indicator ? other : THROW_CCE();
    if (!equals(this.d2b_1, tmp0_other_with_cast.d2b_1))
      return false;
    if (!(this.e2b_1 === tmp0_other_with_cast.e2b_1))
      return false;
    return true;
  };
  function ObjectRefDTO() {
  }
  function OrganizationRefDTO() {
  }
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = new ArrayListSerializer(StringSerializer_getInstance());
    var tmp_1 = getKClass(ExternalFileDTO);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2b_1 = [null, null, null, tmp_0, null, null, PolymorphicSerializer_init_$Create$(tmp_1, tmp$ret$2)];
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function $serializer_11() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.commons.domain.model.OrganizationRef', this, 7);
    tmp0_serialDesc.ht('objectType', true);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('roles', false);
    tmp0_serialDesc.ht('location', true);
    tmp0_serialDesc.ht('website', true);
    tmp0_serialDesc.ht('img', true);
    this.i2b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).ii = function () {
    return this.i2b_1;
  };
  protoOf($serializer_11).wt = function () {
    var tmp0_cached = Companion_getInstance_4().h2b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[6])];
  };
  protoOf($serializer_11).ki = function (decoder) {
    var tmp0_desc = this.i2b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.ul(tmp0_desc);
    var tmp12_cached = Companion_getInstance_4().h2b_1;
    if (tmp11_input.km()) {
      tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.gm(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.im(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.gm(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.im(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.vl(tmp0_desc);
    return OrganizationRef_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_11).j2b = function (encoder, value) {
    var tmp0_desc = this.i2b_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().h2b_1;
    if (tmp1_output.rn(tmp0_desc, 0) ? true : !(value.k2b_1 === 'organization')) {
      tmp1_output.jn(tmp0_desc, 0, value.k2b_1);
    }
    tmp1_output.jn(tmp0_desc, 1, value.l2b_1);
    tmp1_output.jn(tmp0_desc, 2, value.m2b_1);
    tmp1_output.ln(tmp0_desc, 3, tmp2_cached[3], value.n2b_1);
    if (tmp1_output.rn(tmp0_desc, 4) ? true : !(value.o2b_1 == null)) {
      tmp1_output.nn(tmp0_desc, 4, StringSerializer_getInstance(), value.o2b_1);
    }
    if (tmp1_output.rn(tmp0_desc, 5) ? true : !(value.p2b_1 == null)) {
      tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.p2b_1);
    }
    if (tmp1_output.rn(tmp0_desc, 6) ? true : !(value.q2b_1 == null)) {
      tmp1_output.nn(tmp0_desc, 6, tmp2_cached[6], value.q2b_1);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_11).ji = function (encoder, value) {
    return this.j2b(encoder, value instanceof OrganizationRef ? value : THROW_CCE());
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_11();
    return $serializer_instance_10;
  }
  function OrganizationRef_init_$Init$(seen1, objectType, id, name, roles, location, website, img, serializationConstructorMarker, $this) {
    if (!(14 === (14 & seen1))) {
      throwMissingFieldException(seen1, 14, $serializer_getInstance_10().i2b_1);
    }
    if (0 === (seen1 & 1))
      $this.k2b_1 = 'organization';
    else
      $this.k2b_1 = objectType;
    $this.l2b_1 = id;
    $this.m2b_1 = name;
    $this.n2b_1 = roles;
    if (0 === (seen1 & 16))
      $this.o2b_1 = null;
    else
      $this.o2b_1 = location;
    if (0 === (seen1 & 32))
      $this.p2b_1 = null;
    else
      $this.p2b_1 = website;
    if (0 === (seen1 & 64))
      $this.q2b_1 = null;
    else
      $this.q2b_1 = img;
    return $this;
  }
  function OrganizationRef_init_$Create$(seen1, objectType, id, name, roles, location, website, img, serializationConstructorMarker) {
    return OrganizationRef_init_$Init$(seen1, objectType, id, name, roles, location, website, img, serializationConstructorMarker, objectCreate(protoOf(OrganizationRef)));
  }
  function OrganizationRef() {
  }
  protoOf(OrganizationRef).x27 = function () {
    return this.k2b_1;
  };
  protoOf(OrganizationRef).k1y = function () {
    return this.l2b_1;
  };
  protoOf(OrganizationRef).h9 = function () {
    return this.m2b_1;
  };
  protoOf(OrganizationRef).c23 = function () {
    return this.n2b_1;
  };
  protoOf(OrganizationRef).f2b = function () {
    return this.o2b_1;
  };
  protoOf(OrganizationRef).g2b = function () {
    return this.p2b_1;
  };
  protoOf(OrganizationRef).toString = function () {
    return 'OrganizationRef(objectType=' + this.k2b_1 + ', id=' + this.l2b_1 + ', name=' + this.m2b_1 + ', roles=' + this.n2b_1 + ', location=' + this.o2b_1 + ', website=' + this.p2b_1 + ', img=' + this.q2b_1 + ')';
  };
  protoOf(OrganizationRef).hashCode = function () {
    var result = getStringHashCode(this.k2b_1);
    result = imul(result, 31) + getStringHashCode(this.l2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2b_1) | 0;
    result = imul(result, 31) + hashCode(this.n2b_1) | 0;
    result = imul(result, 31) + (this.o2b_1 == null ? 0 : getStringHashCode(this.o2b_1)) | 0;
    result = imul(result, 31) + (this.p2b_1 == null ? 0 : getStringHashCode(this.p2b_1)) | 0;
    result = imul(result, 31) + (this.q2b_1 == null ? 0 : hashCode(this.q2b_1)) | 0;
    return result;
  };
  protoOf(OrganizationRef).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationRef))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationRef ? other : THROW_CCE();
    if (!(this.k2b_1 === tmp0_other_with_cast.k2b_1))
      return false;
    if (!(this.l2b_1 === tmp0_other_with_cast.l2b_1))
      return false;
    if (!(this.m2b_1 === tmp0_other_with_cast.m2b_1))
      return false;
    if (!equals(this.n2b_1, tmp0_other_with_cast.n2b_1))
      return false;
    if (!(this.o2b_1 == tmp0_other_with_cast.o2b_1))
      return false;
    if (!(this.p2b_1 == tmp0_other_with_cast.p2b_1))
      return false;
    if (!equals(this.q2b_1, tmp0_other_with_cast.q2b_1))
      return false;
    return true;
  };
  function AuthedUserDTO() {
  }
  function hasRole(_this__u8e3s4, role) {
    return contains(_this__u8e3s4.roles, role);
  }
  function hasRoles(_this__u8e3s4, roles) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var tmp1_all_this = _this__u8e3s4.roles;
      var inductionVariable = 0;
      var last = roles.length;
      while (inductionVariable < last) {
        var element = roles[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!contains(tmp1_all_this, element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function Roles() {
    this.ADMIN = 'admin';
    this.USER = 'user';
    this.Admin = 'admin';
    this.Charpentier = 'Charpentier';
    this.COFOR = 'COFOR';
    this.ExploitantForestier = 'Exploitant forestier';
    this.Financeur = 'Financeur';
    this.Lamelliste = 'Lamelliste';
    this.Moe = "Maitre d'oeuvre";
    this.Moa = "Maitre d'ouvrage";
    this.Marque = 'Marque';
    this.Menuisier = 'Menuisier';
    this.Negoce = 'N\xE9goce';
    this.Scieur = 'Scieur';
  }
  protoOf(Roles).s2b = function () {
    return this.ADMIN;
  };
  protoOf(Roles).t2b = function () {
    return this.USER;
  };
  protoOf(Roles).u2b = function () {
    return this.Admin;
  };
  protoOf(Roles).v2b = function () {
    return this.Charpentier;
  };
  protoOf(Roles).w2b = function () {
    return this.COFOR;
  };
  protoOf(Roles).x2b = function () {
    return this.ExploitantForestier;
  };
  protoOf(Roles).y2b = function () {
    return this.Financeur;
  };
  protoOf(Roles).z2b = function () {
    return this.Lamelliste;
  };
  protoOf(Roles).a2c = function () {
    return this.Moe;
  };
  protoOf(Roles).b2c = function () {
    return this.Moa;
  };
  protoOf(Roles).c2c = function () {
    return this.Marque;
  };
  protoOf(Roles).d2c = function () {
    return this.Menuisier;
  };
  protoOf(Roles).e2c = function () {
    return this.Negoce;
  };
  protoOf(Roles).f2c = function () {
    return this.Scieur;
  };
  var Roles_instance;
  function Roles_getInstance() {
    return Roles_instance;
  }
  //region block: post-declaration
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(Address), 'city', function () {
    return this.j28();
  });
  defineProp(protoOf(Address), 'street', function () {
    return this.h28();
  });
  defineProp(protoOf(Address), 'postalCode', function () {
    return this.i28();
  });
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(City), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(City), 'code', function () {
    return this.m1y();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(CreditedFile), 'file', function () {
    return this.t28();
  });
  defineProp(protoOf(CreditedFile), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(CreditedFile), 'credit', function () {
    return this.u28();
  });
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(CreditedFileCommand), 'toAdd', function () {
    return this.a29();
  });
  defineProp(protoOf(CreditedFileCommand), 'toRemove', function () {
    return this.b29();
  });
  defineProp(protoOf(CreditedFileCommand), 'toUseAsCover', function () {
    return this.c29();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(Department), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(Department), 'code', function () {
    return this.m1y();
  });
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(ExternalFile), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ExternalFile), 'url', function () {
    return this.v21();
  });
  defineProp(protoOf(ExternalFile), 'path', function () {
    return this.m29();
  });
  defineProp(protoOf(ExternalFile), 'metadata', function () {
    return this.w27();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(GeoCoordinates), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(GeoCoordinates), 'longitude', function () {
    return this.y29();
  });
  defineProp(protoOf(GeoCoordinates), 'latitude', function () {
    return this.z29();
  });
  protoOf($serializer_6).xt = typeParametersSerializers;
  protoOf($serializer_7).xt = typeParametersSerializers;
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(IdRef), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_10).xt = typeParametersSerializers;
  defineProp(protoOf(Indicator), 'value', function () {
    return this.f2();
  });
  defineProp(protoOf(Indicator), 'unit', function () {
    return this.a2b();
  });
  protoOf($serializer_11).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationRef), 'objectType', function () {
    return this.x27();
  });
  defineProp(protoOf(OrganizationRef), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OrganizationRef), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OrganizationRef), 'roles', function () {
    return this.c23();
  });
  defineProp(protoOf(OrganizationRef), 'location', function () {
    return this.f2b();
  });
  defineProp(protoOf(OrganizationRef), 'website', function () {
    return this.g2b();
  });
  //endregion
  //region block: init
  METADATA_CREDIT_KEY = 'credit';
  Roles_instance = new Roles();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    defineProp($org$boislocal$platform$s2$commons$domain$model, 'METADATA_CREDIT_KEY', get_METADATA_CREDIT_KEY);
    $org$boislocal$platform$s2$commons$domain$model.ExternalFile = ExternalFile;
    defineProp($org$boislocal$platform$s2$commons$domain$model.ExternalFile, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org$boislocal$platform$s2$commons$domain$model$auth = $org$boislocal$platform$s2$commons$domain$model.auth || ($org$boislocal$platform$s2$commons$domain$model.auth = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$commons = $org$boislocal$platform$s2.commons || ($org$boislocal$platform$s2.commons = {});
    var $org$boislocal$platform$s2$commons$domain = $org$boislocal$platform$s2$commons.domain || ($org$boislocal$platform$s2$commons.domain = {});
    var $org$boislocal$platform$s2$commons$domain$model = $org$boislocal$platform$s2$commons$domain.model || ($org$boislocal$platform$s2$commons$domain.model = {});
    var $org$boislocal$platform$s2$commons$domain$model$auth = $org$boislocal$platform$s2$commons$domain$model.auth || ($org$boislocal$platform$s2$commons$domain$model.auth = {});
    defineProp($org$boislocal$platform$s2$commons$domain$model$auth, 'Roles', Roles_getInstance);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_init_$Create$;
  _.$_$.b = Roles_instance;
  _.$_$.c = $serializer_getInstance;
  _.$_$.d = $serializer_getInstance_0;
  _.$_$.e = $serializer_getInstance_2;
  _.$_$.f = $serializer_getInstance_3;
  _.$_$.g = $serializer_getInstance_4;
  _.$_$.h = $serializer_getInstance_6;
  _.$_$.i = $serializer_getInstance_5;
  _.$_$.j = $serializer_getInstance_9;
  _.$_$.k = $serializer_getInstance_10;
  _.$_$.l = hasRoles;
  _.$_$.m = hasRole;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-infra-commons-commons-domain.js.map
